import React from 'react';
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import './LeaderboardTable.scss'
import gold from "../../../assets/img/icons8-médaille-d'or-olympique-48.png"
import silver from "../../../assets/img/icons8-médaille-d'argent-olympique-48.png"
import bronze from "../../../assets/img/icons8-médaille-de-bronze-olympique-48.png"
import {round} from "../../../utils/services";
import {useTranslation} from "react-i18next";
import constants from "../../../utils/constants";
import {Auth} from "../../../utils/Auth";

const LeaderboardTable = ({data}) => {

    const {t} = useTranslation();
    const auth = new Auth();

    function toFloat(string){
        return parseFloat(string.replace('%', ''))
    }

    return (
        <TableContainer component={Paper} sx={{ boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', borderRadius: '15px', overflow: 'hidden' }}>
            <Table className="leaderboardTable" aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell className="tableHeader">{t('leaderboard.table.rank')}</TableCell>
                        <TableCell className="tableHeader">{t('leaderboard.table.username')}</TableCell>
                        <TableCell className="tableHeader">{t('leaderboard.table.wallet')}</TableCell>
                        <TableCell className="tableHeader" align="right">{t('leaderboard.table.profit')}</TableCell>
                        <TableCell className="tableHeader" align="right">{t('leaderboard.table.performance')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.leaderboard.slice(0, 15).map((row, index) => {
                        const isCurrentUser = auth.getUsername() === row.username;
                        return (
                        <TableRow key={row.username} className={isCurrentUser ? 'current-user-row' : ''}>
                            <TableCell data-label={t('leaderboard.table.rank')} className="tableCell" component="th" scope="row">
                                <span className={`${isCurrentUser ? 'font-bold' : ''}`} style={{ color: '#64748b', fontWeight: '500' }}>
                                {
                                    (row.rank === 1 && toFloat(row.percentage)) ? <img style={{width: "30px",transform:"translateX(-10px)"}} src={gold} alt="medal"/>
                                        : ( row.rank === 2 && toFloat(row.percentage)) ? <img style={{width: "30px",transform:"translateX(-10px)"}} src={silver} alt="medal"/>
                                            : (row.rank === 3 && toFloat(row.percentage)) ? <img style={{width: "30px",transform:"translateX(-10px)"}} src={bronze} alt="medal"/>
                                                : `#${row.rank}`
                                }
                                </span>
                            </TableCell>
                            <TableCell data-label={t('leaderboard.table.username')} className="tableCell">
                                <span className={`${isCurrentUser ? 'font-bold' : ''}`} style={{ color: '#1e293b', fontWeight: isCurrentUser ? '700' : '500' }}>
                                    {row.username}
                                </span>
                            </TableCell>
                            <TableCell data-label={t('leaderboard.table.wallet')} className="tableCell">
                                <span style={{ fontWeight: '600', color: '#0f172a' }} className={`${isCurrentUser ? 'font-bold' : ''}`}>
                                    {`${round(row.totalValue, 2)} $`}
                                </span>
                            </TableCell>
                            <TableCell data-label={t('leaderboard.table.profit')} className="tableCell" align="right">
                                {(() => {
                                    const profit = row.totalValue - constants.starting_money;
                                    const isPositive = profit >= 0;
                                    const colorPrice = isPositive ? constants.green : constants.red;
                                    return (
                                        <span style={{ color: colorPrice, fontWeight: '700', fontVariantNumeric: 'tabular-nums' }}>
                                            {isPositive ? '+' : ''}{round(profit, 2)} $
                                        </span>
                                    );
                                })()}
                            </TableCell>
                            <TableCell data-label={t('leaderboard.table.performance')} className="tableCell" align="right">
                                {(() => {
                                    const val = toFloat(row.percentage);
                                    const isPositive = val >= 0;
                                    const colorPrice = isPositive ? constants.green : constants.red;
                                    const backgroundColor = colorPrice.includes('rgb') 
                                        ? colorPrice.replace('rgb', 'rgba').replace(')', ', 0.1)') 
                                        : colorPrice + "1A";
                                    return (
                                        <span 
                                            className="gain-loss-pill" 
                                            style={{ color: colorPrice, backgroundColor }}
                                        >
                                            {isPositive ? '+' : ''}{row.percentage}
                                        </span>
                                    );
                                })()}
                            </TableCell>

                        </TableRow>
                    )})}
                    {data.user && data.user.rank > 15 &&
                        <>
                            <TableRow>
                                <TableCell colSpan={5} className="divider-cell">
                                    <div className="divider-line"></div>
                                </TableCell>
                            </TableRow>
                            <TableRow className="current-user-row">
                                <TableCell data-label={t('leaderboard.table.rank')} className="tableCell">
                                    <span style={{ color: '#64748b', fontWeight: '500' }}>
                                        {`#${data.user.rank}`}
                                    </span>
                                </TableCell>
                                <TableCell data-label={t('leaderboard.table.username')} className="tableCell">
                                    <span style={{ color: '#1e293b', fontWeight: '700' }}>
                                        {data.user.username}
                                    </span>
                                </TableCell>
                                <TableCell data-label={t('leaderboard.table.wallet')} className="tableCell">
                                    <span style={{ fontWeight: '600', color: '#0f172a' }}>
                                        {round(data.user.totalValue,2)} $
                                    </span>
                                </TableCell>
                                <TableCell data-label={t('leaderboard.table.profit')} className="tableCell" align="right">
                                    {(() => {
                                    const profit = data.user.totalValue - constants.starting_money;
                                    const isPositive = profit >= 0;
                                    const colorPrice = isPositive ? constants.green : constants.red;
                                    return (
                                        <span style={{ color: colorPrice, fontWeight: '700', fontVariantNumeric: 'tabular-nums' }}>
                                            {isPositive ? '+' : ''}{round(profit, 2)} $
                                        </span>
                                    );
                                    })()}
                                </TableCell>
                                <TableCell data-label={t('leaderboard.table.performance')} className="tableCell" align="right">
                                    {(() => {
                                        const val = toFloat(data.user.percentage);
                                        const isPositive = val >= 0;
                                        const colorPrice = isPositive ? constants.green : constants.red;
                                        const backgroundColor = colorPrice.includes('rgb') 
                                            ? colorPrice.replace('rgb', 'rgba').replace(')', ', 0.1)') 
                                            : colorPrice + "1A";
                                        return (
                                            <span 
                                                className="gain-loss-pill" 
                                                style={{ color: colorPrice, backgroundColor }}
                                            >
                                                {isPositive ? '+' : ''}{data.user.percentage}
                                            </span>
                                        );
                                    })()}
                                </TableCell>
                            </TableRow>
                        </>
                    }


                </TableBody>
            </Table>
        </TableContainer>
    )
        ;
};

export default LeaderboardTable;